import axios from 'App/axios';

interface LendingOffer {
  id: string;
  availableLimit: number;
  active: boolean;
  segment?: string;
}

export const getOffer = async (): Promise<LendingOffer> => {
  const { data } = await axios.get('/v1/lending/offers');
  return data;
};

export const hasFeature = async (toggle: string): Promise<boolean> => {
  const { data } = await axios.get(`/v1/lending/toggles/${toggle}`);
  return data;
};
